( function () {
    'use strict';

    let container = document.querySelector('.page-links-actions');

    init();

    /**
     * Инициализация
     *
     */
    function init() {
        if (!container) {
            return;
        }

        onLinkClick();
    }

    /**
     * Обработка клика по ссылкам
     *
     */
    function onLinkClick() {
        container.addEventListener('click', function (evt) {
            if (evt.target.tagName.toLowerCase() === 'a') {
                if (evt.target.parentElement.classList.contains('page-links-actions__item--download')) {
                    evt.preventDefault();
                    window.scrollToElement(document.querySelector(evt.target.hash));
                }
            }
        });
    }

}());

